import { Pipe, PipeTransform } from '@angular/core';
import { CreateNumericLabelPipe } from '../create-numeric-label.pipe';

@Pipe({
  name: 'createThicknessLabel',
})
export class CreateThicknessLabelPipe implements PipeTransform {
  constructor(private numericLabelPipe: CreateNumericLabelPipe) {}

  transform(value: number, uomName: string, suffix: string, displayNoDataMessage: boolean = false): string {
    if (!uomName && !displayNoDataMessage) {
      return '';
    }
    const transformedValue: string = this.numericLabelPipe.transform(value, false);

    if (!transformedValue) {
      return 'No Data';
    }

    const valueWithUom: string = `${transformedValue} ${uomName}`;

    if (!suffix) {
      return valueWithUom;
    }

    return `${valueWithUom} ${suffix}`;
  }
}
